
import * as ipxRuntime$DEC0865Tgy from 'C:/Users/HP/WebstormProjects/Altela/node_modules/@nuxt/image-edge/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$DEC0865Tgy, defaults: {} }
}
        